let _bizmatesSiteBaseUrl = process.env['VUE_APP_BIZMATES_URL'] || null;
let _mystageBackendBaseUrl = process.env['VUE_APP_MSB_URL'] || null;
export const isCmsPreview = window.location.href.indexOf("/cms-preview/") > -1;
const isNewStudentDashboard = window.location.href.indexOf("-student.dev.bizmates.jp") > -1;
export const appBizmatesUrl = (isNewStudentDashboard ? (process.env['VUE_APP_BIZMATES_STUDENT_URL'] || null) : (process.env['VUE_APP_BIZMATES_URL'] || null));
export const bizmatesSiteBaseUrl = appBizmatesUrl ? appBizmatesUrl.replace('#/$#', '') : (_bizmatesSiteBaseUrl ? _bizmatesSiteBaseUrl.replace('#/$#', '') : null);
export const bizmatesSiteHomeUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/home' : null;
export const bizmatesSiteContactUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/student/inquiry' : null;
export const bizmatesApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api/mystage' : null;
export const bizmatesWordbookApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api/wordbook' : null;
export const myStageApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api/mystage' : null;
export const myStageCmsApiBaseUrl = bizmatesSiteBaseUrl ? process.env.VUE_APP_CMS_API_URL + '/mystage' : null;
export const myBizmatesApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api' : null;
export const bizmatesGraphQlEndpoint = '/graphql';
export const myStageGraphQlEndpoint = _mystageBackendBaseUrl ? _mystageBackendBaseUrl + '/graphql' : '/MyStage/graphql';
export const myStageBackendBaseUrl = _mystageBackendBaseUrl || null;
export const myStageTokenCookieName = 'mystage_token';
export const myStageRefreshTokenCookieName = 'mystage_refresh_token';
export const myStageServiceIdCookieName = 'mystage_service_id';
export const myStageStudentTokenCookieName = 'mystage_student_token';
export const mystageServiceIdHeaderName = 'X-Service-Id';

export const publicKey = isCmsPreview ? process.env.VUE_APP_CMS_API_JWT_SECRET : process.env.VUE_APP_RSA_PUBLIC_KEY || null;

export const internetWarning = 2000;
export const internetError = 1000;

export const programs = {
  assessment: 0,
  bizmates: 1,
  other: 2,
  corporate: 3,
  assist_lesson: 4,
  discovery: 5,
  reskilling: 7
};

export const programDescription = {
  1: 'Bizmates Program',
  2: 'Other Programs',
  4: 'Assist Lesson',
  5: 'Bizmates Discovery',
  7: 'Reskilling'
};

export const mainPrograms = {
  1: { name: 'Bizmates Programs', prefix: 'bp' },
  2: { name: 'Other Programs', prefix: 'op' },
  4: { name: 'Assist Lesson', prefix: 'al' },
  5: { name: 'Bizmates Discovery', prefix: 'bd' }
};

// WebRTC provider data block - START
// !! Always maintain data consistency with the IDs, string keys, and names
export const providers = {
  agora: 'agora',
  skyway: 'skyway',
  awschime: 'awschime'
};

export const providerIds = {
  agora: 1,
  skyway: 2,
  awschime: 3
};

export const providerNames = {
  1: 'Agora',
  2: 'Skyway',
  3: 'AWS Chime'
}
// WebRTC provider data block - END

export const contractTypes = [
  {
    id: 0,
    label: 'B2C'
  },
  {
    id: 1,
    label: 'B2B'
  },
  {
    id: 2,
    label: 'B2B2C'
  }
];

export const timeSyncInterval = 900000; // 15 minutes in ms

export const lessonStatus = {
  scheduled: 1,
  ongoing: 2,
  finished: 3,
  warmup: 4
};

export const layoutStyle = {
  default: 1,
  material: 2, // larger lesson material view
  videoScreen: 3 // larger video/screen streaming view
};

export const eventType = {
  userJoined: 11,
  userLeft: 12,
  connectedRtc: 21,
  disconnectedRtc: 22
};

export const lessonResultCode = {
  PENDING_EMERGENCY: -2,
  TRAINER_REQUESTS_SKYPE: -1,
  NO_RESULT: 0,
  LESSON_TAUGHT: 1,
  STUDENT_NOSHOW: 2,
  STUDENT_ABSENT: 3,
  ABSENT_SUB: 4,
  STUDENT_CANCEL: 10,
  TRAINER_SUBSTITUTION: 11,
  ADMIN_CANCEL: 12,
  STUDENT_EMERGENCY: 20,
  ADMIN_EMERGENCY: 22
};

export const browsers= {
  chrome: 'Chrome',
  edge: 'Edge',
  firefox: 'Firefox',
  safari: 'Safari',
  mobileSafari: 'Mobile Safari'
};

export const supportedBrowsers = [
  {
    name: 'Chrome',
    label: 'Google Chrome',
    minVersion: 80,
    os: ['general', 'Windows', 'Mac OS'],
    downloadLink: 'https://www.google.com/intl/en/chrome/'
  },
  {
    name: 'Edge',
    label: 'Microsoft Edge',
    minVersion: 80,
    os: ['Windows'],
    downloadLink: 'https://www.microsoft.com/en-us/edge/'
  },
  {
    name: 'Firefox',
    label: 'Mozilla Firefox',
    minVersion: 74,
    os: ['general', 'Windows', 'Mac OS'],
    downloadLink: 'https://www.mozilla.org/en-US/firefox/all/#product-desktop-release/'
  },
  {
    name: 'Safari',
    label: 'Safari',
    minVersion: 13,
    os: ['Mac OS'],
    downloadLink: 'https://support.apple.com/downloads/safari/'
  },
  {
    name: 'Mobile Safari',
    label: 'Mobile Safari',
    minVersion: 13,
    os: ['iOS'],
    downloadLink: 'https://support.apple.com/downloads/iphone/'
  },
  {
    name: 'Chrome',
    label: 'Google Chrome',
    minVersion: 80,
    os: ['Android'],
    downloadLink:
      'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.android.chrome'
  }
];

export const internetStatus = {
  offline: 'offline',
  online: 'online'
};

export const videoType = {
  youtube: 1,
  jstream: 0
};

export const generateCount = 10;

export const jStreamEvents = {
  playing: 'playing',
  paused: 'paused',
  clicked: 'clicked',
  landing: 'landing'
}

export const vocabulary = {
  defaultCategory: 0
}

export const zoom = {
  out: 100,            // Student_Minimum_Zoom / Default_Zoom (percent)
  in: 200,             // Maximum_Zoom (percent)
  trainerOut: 80,      // Trainer_Minimum_Zoom (percent)
  pdfHtmlStudentOut: 1.0, // Student/Default PDF-HTML scale floor
  pdfHtmlTrainerOut: 0.9  // Trainer PDF-HTML scale floor
};

export const evaluationCharacteristics = [
  {
    value: '特徴と違った',
    icon: 1,
    score: -1
  },
  {
    value: '判断不可',
    icon: 3,
    score: 0
  },
  {
    value: '特徴通り',
    icon: 5,
    score: 1
  }
];

export const evaluationLesson = [
  {
    value: '期待と違った',
    icon: 1,
    score: -1
  },
  {
    value: '判断不可',
    icon: 3,
    score: 0
  },
  {
    value: '期待通り',
    icon: 5,
    score: 1
  }
];

export const dayOfWeek = ['日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'];
export const datePrefix = ['本日', '明日', '明後日'];

export const schedule = {
  morning: 1,
  noon: 2,
  night: 3
};

export const schedules = [
  {
    timeRange: '5:00〜11:55',
    icon: 'fa-sun-o',
    hours: ['05', '06', '07', '08', '09', '10', '11'],
    scheduleData: null
  },
  {
    timeRange: '12:00〜17:55',
    icon: 'fa-coffee',
    hours: ['12', '13', '14', '15', '16', '17', null],
    scheduleData: null
  },
  {
    timeRange: '18:00〜24:55',
    icon: 'fa-moon-o',
    hours: ['18', '19', '20', '21', '22', '23', '24'],
    scheduleData: null
  }
];

export const sliderDeviceSetting = {
  PC: {
    lazyLoad: 'progressive',
    swipe: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: false,
    vertical: false,
    verticalSwiping: false,
    draggable: true,
    arrows: true
  },
  SP: {
    swipe: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    draggable: true,
    arrows: false,
    variableWidth: true
  }
};


export const REVAMP_PREFIX = 'New';

export const errorCodes = {
  ME001: 'ME001',
  ME002: 'ME002',
  ME003: 'ME003',
  ME004: 'ME004',
  ME005: 'ME005'
}

export const materialIsTest = {
  true: 1,
  false: 0,
}

export const materialPreload = {
  default: 1,
}

export const PLATFORM = {
  skype: 1,
  mystage: 2
}

export const CUSTOMER_RATING = {
  veryBad: 1,
  bad: 2,
  neutral: 3,
  good: 4,
  veryGood: 5
}

export const serviceIds = {
  bizmates: 1,
  zipan: 2
}

export const CUSTOMER_FEEDBACK_Q4 = 17;

export const enableCanaryCheck = false;

export const BIZMATES_TIMEZONE_STUDENT = 'Asia/Tokyo';
export const BIZMATES_TIMEZONE_TRAINER = 'Asia/Manila';

export const ZIPAN_TIMEZONE_STUDENT = 'Asia/Tokyo'; // considered as `DEFAULT` timezone, but will change with the user's timezone
export const ZIPAN_TIMEZONE_TRAINER = 'Asia/Tokyo';
export const ZIPAN_TIMEZONE_ADMIN = 'Asia/Tokyo';

// from mst_country table
export const COUNTRY_ID = {
  japan: 86,
  taiwan: 194
}

export const SUPPORTED_LANGUAGES = ['en', 'ja'];

export const COUNTRY_CODE = {
  194: 'tw'
}

export const COUNTRY_NAME = {
  86: 'Japan',
  194: 'Taiwan'
}

export const ACCOUNT_TYPE = {
  student: 's',
  trainer: 't',
  admin: 'a'
};

export const ZIPAN_SITE_URL = process.env.VUE_APP_ZIPAN_URL;

export const MYSTAGE_BASE_URL = process.env.BASE_URL;

export const MAX_RTC_INIT_RELOADS = 3;
